import local from './environments/local.js';
import development from './environments/development.js';
import staging from './environments/staging.js';
import production from './environments/production.js';
import test from './environments/test.js';
export const featureFlags = {
    local,
    development,
    staging,
    production,
    test,
};
//# sourceMappingURL=feature-flags.js.map